import React from 'react';
import './button.css';

const Button = ({
  children,
  text,
  size = 'medium',
  variant = 'primary',
  color,
  textColor,
  onClick,
  disabled = false,
  fullWidth = false,
  outline = false,
  className = '',
  style = {},
  type = 'button',
  ...props
}) => {
  const buttonText = children || text || 'Bouton';

  const buttonClasses = [
    'custom-btn',
    size,
    variant,
    outline ? 'outline' : '',
    fullWidth ? 'full-width' : '',
    className
  ].filter(Boolean).join(' ');

  const customStyle = {
    ...style,
    ...(color && { backgroundColor: color }),
    ...(textColor && { color: textColor }),
    ...(outline && color && { 
      borderColor: color, 
      color: color,
      backgroundColor: 'transparent' 
    })
  };
  
  return (
    <button
      type={type}
      className={buttonClasses}
      style={customStyle}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {buttonText}
    </button>
  );
};

export default Button;